<template>
  <div class="ui segments">

      <div class="ui segment">
        <div class="ui breadcrumb">
          <router-link :to="{name:'home'}" class="section">Sākums</router-link>
          <span class="divider">/</span>
          <router-link :to="{name:'waiting-for-delivery'}" class="section">Gaida piegādi</router-link>
          <span class="divider">/</span>
          <div class="active section">Rediģēt</div>
        </div>
      </div>

 <div class="ui segment" v-bind:class="{ loading: showLoading }">

  <div class="ui form">
    <h2 class="ui dividing header">Jūsu Pasūtijums</h2>
    <!-- second row -->
    <h3 class="ui dividing header">
      <i class="marker icon"></i>
      <div class="content">
        Piegādes informācija
      </div>
    </h3>
	<div v-if="order.delivery_type_id && order.delivery_type_id != 1" style="font-size: 1em; margin-bottom: 10px;"><b>{{order.delivery_type}}</b><span v-if="order.parcel_machine_location && order.parcel_machine_location != ''">: {{order.parcel_machine_location}}</span></div>
    <div class="two fields">
        <div class="field">
          <label v-if="order.address_id > 0">Adrese</label>
          <select v-if="order.address_id > 0" :disabled="!order.delivery_type_id || order.delivery_type_id == 1 ? false:true" class="ui fluid dropdown" @change="changeDeliveryAddress($event.target.value)">
                <option v-for="item in address" :value="item.id" :selected="item.id == order.address_id ? true:false">{{item.street}}<span v-if="item.house_no !=''">&nbsp;</span>{{item.house_no}}<span v-if="item.flat_no !=''">,&nbsp;</span>{{item.flat_no}}<span v-if="item.city_label !=''">,&nbsp;</span>{{item.city_label}}</option>
          </select>
        </div>
        <div class="field">
          <label>&nbsp;</label>
          <a v-if="!order.delivery_type_id || order.delivery_type_id == 1" @click="showDeliveryZones">Piegādes reģionu karte</a>

          <!-- delivery address zones -->
          <div class="ui modal" id="delivery-zone">
            <i class="close icon"></i>
            <div class="image content">
              <div class="ui  image">
                <img src="https://api.memorywater.lv/img/documents/piegades-teritorija.png">
              </div>
            </div>
          </div>
		  <!-- end of delivery addres zones -->
		  
        </div>
    </div>



 <!-- forth row -->
 <div class="two fields">
   <div v-if="!order.delivery_type_id || order.delivery_type_id == 1" class="ui calendar field" id="start_date" >
     <label>Piegādes datums</label>
     <div class="ui input left icon">
       <i class="calendar icon"></i>
       <input type="text" placeholder="Norādit piegādes datumu" :value="order.delivery_date">
     </div>
   </div>
 </div>

 <!-- goods row -->
 <h3 class="ui dividing header">
   <i class="shop icon"></i>
   <div class="content">
     Preces
   </div>
 </h3>





<div class="ui container">
  <div  class="ui attached segment" v-bind:class="{ loading: storeStatus.loading }">

    <div class="ui form">
      <!-- goods row -->
      <div v-if="itemsInCart>0" class="ui divided items">
        <div v-for="item in items" class="item">
          <div class="ui tiny image" @click="$router.push('/good/'+item.link)" style="cursor:pointer">
            <img  v-if="item.images[0]" :src="item.images[0].url" />
            <img  v-else :src="'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/'+item.good_id+'.jpg'" />
          </div>
          <div class="content">
            <router-link :to="'/good/'+item.link"  class="header">{{item.name}}</router-link>
            <div class="meta">
              <div class="ui tag labels">
                <a class="ui custom_brown label">
                Cena: {{item.price_vat}} &euro;
              </a>
                <a v-if="item.bail>0" class="ui green label">
                Drošības nauda: {{item.bail}} &euro;
              </a>
              </div>
              <!--span class="cinema">Cena {{item.price_vat}} &euro; gab.<span v-if="item.bail>0">, Drošības nauda {{item.bail}} &euro;</span></span-->
            </div>
            <div class="description">
              <p>{{item.description}}</p>
            </div>
            <div class="extra">


              <div class="ui grid">
                <div class="fourteen wide column">
                  <div class="ui right floated">
              <div class="ui left floated inline fields">
                  <label style="width:85px; text-align:right">Pasūtīšu: &nbsp; x</label>
                  <div class="field">
                      <input :disabled="(order.delivery_type_id && order.delivery_type_id != 1) || (order.lock == 1 || order.details.status == 4)" type="text" placeholder="skaits" @keyup="updateCartItemOrder(item, $event.target.value)" :value="item.order" style="width:70px" number>
                  </div>
              </div>
              <div v-if="item.isrentable == 1" class="ui left floated inline fields">
                  <label style="width:85px; text-align:right">Atgriezīšu: &nbsp; x</label>
                  <div class="field">
                      <input :disabled="(order.lock == 1 || order.details.status == 4)" type="text" placeholder="skaits" @keyup="updateCartItemReturn(item, $event.target.value)" :value="item.return" style="width:70px" number>

                  </div>
              </div>
            </div>
            </div>
              <div class="two wide column" v-if="(!order.delivery_type_id || order.delivery_type_id == 1) && (order.lock == 0 && order.details.status != 4)">
            <button v-on:click="removeItem(item)" class="ui right floated grey icon button">
                <i class="right trash icon"></i>
            </button>
          </div>

            </div>


                <div v-for="badge in item.badges" class="ui label" :style="{ backgroundColor: '#'+badge.color, color: '#210404'}">{{badge.label}}</div>

            </div>
          </div>
        </div>
      </div>

      <div v-if="(!order.delivery_type_id || order.delivery_type_id == 1) && (order.lock == 0 && order.details.status != 4)" class="ui container">
        <button @click="openAddGoodsPage()" class="ui right floated green button">Pievienot preces</button>
        <div class="ui clearing hidden divider"></div>
      </div>

    </div>
  </div>

 <div class="ui clearing hidden divider"></div>
</div>

  </div>

</div>

<div class="ui secondary segment" v-if="itemsInCart > 0 ">
  <h3 class="ui dividing header">
    <i class="money icon"></i>
    <div class="content">
      Kopsavilkums
    </div>
  </h3>


  <div class="ui two column grid">
    <div class="row">
      <div class="ui column form">

            <div class="ui field">
              <label>Apmaksas veids</label>
              <select class="ui fluid dropdown" disabled>
                <option value="3" :selected="order.payment_type == 3">Skaidrā saņemot preci</option>
                <option value="2" :selected="order.payment_type == 2">No konta</option>
                <option value="6" :selected="order.payment_type == 6">Bankas maksājumu karti (VISA/Mastercard)</option>
                <option value="10" :selected="order.payment_type == 10">Swedbank internetbanku</option>
                <option value="7" :selected="order.payment_type == 7">SEB internetbanku</option>
                <option value="8" :selected="order.payment_type == 8">Citadele internetbanku</option>
                <option value="9" :selected="order.payment_type == 9">Nordea internetbanku</option>
                <option value="5" :selected="order.payment_type == 5">Pēcapmaksu</option>

              </select>
            </div>

        <div class="ui field">
            <label>Komentāri</label>
            <textarea rows="4"  :value="order.notes" @change="updateOrder('notes', $event.target.value)"></textarea>
          </div>
      </div>
      <div class="column">
        <div style="float:right;" v-if="order.details">
          <div class="ui list" style="text-align:right; margin-top:30px">
            <div class="item"><b>Nākamā pasūtījuma summa:</b></div>
            <div class="item" v-if="order.details.water_goods_price_vat>0">Ūdens 18,9l: {{order.details.water_goods_price_vat}} &euro;</div>
            <div class="item" v-if="order.details.services_price_vat>0">Pakalpojums: {{order.details.services_price_vat}} &euro;</div>
            <div class="item" v-if="order.details.no_water_goods_price_vat>0">Citas preces: {{order.details.no_water_goods_price_vat}} &euro;</div>
            <div class="item" v-if="order.details.bail != 0" style="color:#E12F2E"><span id="bail" data-content="Turpiniet, ievadot piegādes datumu un pārbaudiet veikto pasūtījumu. Ņemiet vērā, ka par katru lietošanā esošo pudeli jāmaksā drošības nauda. Drošības nauda tiks atgriezta pēc tukšo pudeļu atdošanas">Drošības nauda: {{order.details.bail}} &euro;</span></div>
            <div class="item" v-if="order.details.deposit_amount != 0"><span id="deposit">Depozīts: {{order.details.deposit_amount}} &euro;</span></div>
			<div class="item" v-if="(order.details.extra_delivery != 0) && (order.details.water_goods_price_vat > 0) && (order.details.water_goods_price_vat + order.details.no_water_goods_price_vat < 20)" style="color:#E12F2E"><span id="delivery" data-html="Degvielas piemaksa netiks pievienota, ja pasūtīsiet produktus par vismaz 20 EUR."><i class="info circle icon" data-html="Degvielas piemaksa netiks pievienota, ja pasūtīsiet produktus par vismaz 20 EUR."></i>Mainīgā degvielas piemaksa: {{order.details.extra_delivery}} &euro;</span></div>
			<div class="item" v-else-if="(order.details.extra_delivery != 0)" style="color:#E12F2E"><span id="delivery" data-html="Piegādes maksa netiks pievienota, ja pasūtīsiet produktus par vismaz 20 EUR.">Piegāde: {{order.details.extra_delivery}} &euro;</span></div>
            <div class="item"><b>Kopsumma: {{order.details.total_price_with_bail_and_vat}} &euro;</b></div>
            <div class="item" v-if="order.details.bonus>0" style="color:#21BA45"><span id="bonus_delivery" data-content="Par katru Memory Water 18,9l pasūtījumu jūs saņemat 2% bio un citu veselīgu produktu iegādei">Bonuss: + {{order.details.bonus}} &euro; </span></div>

          </div>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="column"></div>
      <div class="column">

        <div class="ui right floated buttons">
        <button class="ui button" @click="$router.push({name:'waiting-for-delivery'})">Atpakaļ</button>
        <div v-if="(!order.delivery_type_id || order.delivery_type_id == 1) && (order.lock == 0 && order.details.status != 4)" class="or" data-text="vai"></div>
        <button v-if="(!order.delivery_type_id || order.delivery_type_id == 1) && (order.lock == 0 && order.details.status != 4)" class="ui custom_brown button" @click="initiateProcessCartOrder()" :class="{ disabled: order.delivery_date == ''}" >Saglabāt</button>
        </div>

      </div>
    </div>
  </div>




    <div class="ui clearing hidden divider"></div>
</div>

<!-- Confirmation prompt for autoship orders  -->
<div id="waiting-delivery-autoship-date-change-dialog" class="ui basic modal">
  <div class="ui icon header">
    <i class="help circle icon"></i>
    Aiznākamo Autoship pasūtījumu plānots piegādāt:  {{localDay(nextDelivery.delivery_day)}}, {{nextDelivery.delivery_date}}.
  </div>
  <div class="content">
    <p>Vai vēlaties mainīt Autoship piegādes regularitātes iestatījumus visiem nākotnes pasūtījumiem?</p>
  </div>
  <div class="actions">
    <div class="ui custom_brown basic cancel inverted button" @click="changeAutoship(false)">
      <i class="remove icon"></i>
      Nē, nemainīt
    </div>
    <div class="ui green ok inverted button" @click="changeAutoship(true)">
      <i class="checkmark icon"></i>
      Jā, mainīt
    </div>
  </div>
</div>


</div>


</template>

<script>

export default {
  data() {
      return {
          extraParams:{
            change_autoship: false
          },
          originalDeliveryDate:'',
          showLoading: false,
          deleteOnExit:true, //if true then on exit order cart will be deleted. False set only once order (cart) is saved
      }
  },
 computed: {
   storeStatus() {
     return this.$store.state.orderStore.status
   },
   order() {
     return this.$store.state.orderStore.details;
   },
   user() {
     return this.$store.state.userStore.user
   },
   address() {
     return this.$store.state.addressStore.items
   },
   items() {
     return this.$store.state.orderStore.cartitems
   },
   itemsInCart() {
     return this.$store.state.orderStore.cartitems.length;

   },
   nextDelivery() {
     return this.$store.state.autoShipStore.nextDelivery;

   },


 },


  activated(){
    //reset values
    this.extraParams.change_autoship = false;
    this.showLoading = false;
    this.deleteOnExit = true;

    var id = (this.$route.params.id) ? this.$route.params.id : 0;
    //load only once and if not matching so that page is not related when user goes to add goods page for autoship and change state in autoship form

    //if(this.autoship.id != id){

      this.$store.dispatch('loadOrderDetails',id).then((response) => {
        //will be used to compare delivery date changes
        this.originalDeliveryDate = response.data.data.delivery_date;

        this.$store.dispatch('loadOrderItems', this.order.id);
        this.$store.dispatch('loadAddress').then(() => {
          this.activateCalendar(this.order.address_id);
        });

        this.enablePopups();

      }).catch((error) => {
        console.error('Cart was not loaded')
        //go back to previous page
        this.$router.push({
            name: 'waiting-for-delivery',
        });
      });

  },

  deactivated(){
    //check if cart should be deleted on exit
     if(this.deleteOnExit) this.deleteOrderCart();
  },

  watch: {
      "order": function() {
          this.enablePopups();
      }
  },

  methods:{

	openAddGoodsPage(){

		this.deleteOnExit = false;

        this.$router.push({
            name: 'waiting-for-delivery-addgoods',
			params:{
				id:this.order.id,
				page:1
			}
        });


	},

    enablePopups: _.debounce(function() {
        $('#bail').popup();
        $('#delivery').popup();
        $('#bonus_delivery').popup();
    }, 500),


    localDay(day){
      var days = ['','Pirmdien', 'Otrdien', 'Trešdien', 'Ceturtdien', 'Piekdien', 'Sestdien', 'Svētdien']
      return days[day];
    },

      //activate popup
      showDeliveryZones(){
        $('#delivery-zone')
          .modal('show');
      },

      //update order data to recalculate total amount
      updateOrder(field,value){
        var order = JSON.parse(JSON.stringify(this.order));
        order[field] = value
        this.$store.dispatch('updateCartOrder', order);

      },

      changeAutoship(change){

          this.extraParams.change_autoship = change;
          this.processCartOrder()
      },

      initiateProcessCartOrder(){
        //if for autoship date is changed then ask what to do


        if(this.originalDeliveryDate != this.order.delivery_date && this.order.original_id > 0){
            //original_id is autoship_id from which order is originated
          this.showLoading = true;
          this.$store.dispatch('getNextDelivery',this.order).then((response) => {
            this.showLoading = false;
            $('#waiting-delivery-autoship-date-change-dialog')
              .modal('show');

          }).catch((error) => {
            this.showLoading = false;
            console.error('Order was not updated correctly')
            this.$router.push({
              name: 'waiting-for-delivery',
            });
          });





        }
        else{
          this.processCartOrder()
        }
      },

      processCartOrder(){

          this.deleteOnExit = false;
          //if all ok then process
          this.$store.dispatch('processCartOrder', [this.order,this.extraParams]).then((response) => {
            //if autoship was changed the move to autoship list

            if(this.extraParams.change_autoship){
              this.$router.push({
                name: 'autoship',
              });
            }
            else{
              this.$router.push({
                name: 'waiting-for-delivery',
              });
            }

          }).catch((error) => {
            console.error('Order was not processed')
          });


      },


      deleteOrderCart(){

        this.$store.dispatch('deleteOrderCart', this.order).then((response) => {

            this.$router.push({
              name: 'waiting-for-delivery',
            });


        }).catch((error) => {
          console.error('Order cart was not deleted')
        });

      },

  /* calendar logic */
  isDateDisabled(date, mode, addressId) {
      if (date) {
          var address = this.getSelectedAddress(addressId);
          if (!address) return true;

          //check if date is in the past + 1
          if(date <= new Date()){
            return true;
          }
          
          //check if there is restricted dates for address. If dates are in past then user will not be able to select any date!
          else if (address.allowed_dates != "") {
              //add ";" in front of date string and when searching for ;d-m-yyyy. This is required
              //to ensure that 5-12-2016 would not match with 15-12-2016
              var dmy = ";" + date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
              address.allowed_dates = ";" + address.allowed_dates;
              if (address.allowed_dates && address.allowed_dates.indexOf(dmy) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                  //return false;
                  
                  //days config override
                  var dm = ';' + date.getDate() + "-" + (date.getMonth() + 1) + ';';
                  if (address.forbidden_working_days != "" && address.forbidden_working_days.indexOf(dm) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                      return true;
                  } else {
                      return false;
                  }
              } else {
                  //return true;
                  
                  //days config override
                  var dm = ';' + date.getDate() + "-" + (date.getMonth() + 1) + ';';
                  if (date.getDay() == 0) {
                      if (address.allowed_weekends != "" && address.allowed_weekends.indexOf(dm) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                          return false;
                      } else {
                          return true;
                      }
                  }
              }
          } else { //check if weekend is allowed or working day disabled
              var dm = ';' + date.getDate() + "-" + (date.getMonth() + 1) + ';';
              // if day is Sunday then check if its allowed using allowed_weekends attribute
              if (date.getDay() == 0) {
                  if (address.allowed_weekends != "" && address.allowed_weekends.indexOf(dm) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                      return false;
                  } else {
                      return true;
                  }
              } else { //if day is working day or Sat.day
                  //then check if its restricted
                  if (address.forbidden_working_days != "" && address.forbidden_working_days.indexOf(dm) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                      return true;
                  } else {
                      return false;
                  }
              }
          }
      }

      //in all other cases disable date
      return true;
  },

  getSelectedAddress(addressId){
    if (addressId == 0) return false;

    //copy object and find selected address
    var addressObject = JSON.parse(JSON.stringify(this.address));


    var index = addressObject.findIndex(o => o.id == addressId);
    if(index >=0){
      return addressObject[index]
    }
    else {
      console.error('Returning first available address for OrderCart');
      return addressObject[0]
    }
  },
  //small debounce due to render
  activateCalendar: _.debounce(function(addressId){

    //get selected address, used later
    var address = this.getSelectedAddress(addressId);

    //check if next date is not disabled, if it is then try to get next available date
    //first convert yyyy-mm-dd to date
    var st = (this.order.delivery_date) ? this.order.delivery_date : '';
    var pattern = /(\d{2})\-(\d{2})\-(\d{4})/;
    var date = new Date(st.replace(pattern,'$1-$2-$3'));
    //check if not disabled
    if(this.order.delivery_date != "" && this.order.delivery_date != null && !this.isDateDisabled(date, '', addressId)){
      var nextDate = date;
      var nextDateOk = true;
    }
    //if disabled then pick up next available date
    else{

      var nextDate = new Date();
      var nextDateOk = false;
      var i;

      if (address && address.allowed_dates != "") {

        //check if any of next 90 days are within allowed dates
        for (i = 1; i < 90; i++) { //start with tomorrow

              //increment
              nextDate.setDate(nextDate.getDate() + 1);
              var dmy = ";" + nextDate.getDate() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getFullYear();
              address.allowed_dates = ";"+address.allowed_dates;
              //check if its within allowed_dates dates

              if(address.allowed_dates.indexOf(dmy) > -1 && !this.isDateDisabled(nextDate, '', addressId)){
                  nextDateOk = true;
                  break;
              }
        }
      }

      else {
        for (i = 1; i < 90; i++) { //start with tomorrow

              nextDate.setDate(nextDate.getDate() + 1);

              var dm = ';' +  nextDate.getDate() + "-" + (nextDate.getMonth() + 1)  + ';'


              //if weekend then check if its allowed
              //only sundays
              if (nextDate.getDay() == 0) {


                  if(address && address.allowed_weekends != "" && address.allowed_weekends.indexOf(dm) > -1) {
                      nextDateOk = true;
                      break;
                  }
              }
              //if working day then check that its not forbidden

              else if(address && address.forbidden_working_days != "" && address.forbidden_working_days.indexOf(dm) == -1){
                  nextDateOk = true;
                  break;
              }


        }
      }
    }

    //update date in order and calendar

      var day = nextDate.getDate();
      if (day < 10) { day = '0' + day; }
      var month = nextDate.getMonth(); //settings.text.months[];
      month++
      if (month < 10) { month = '0' + month; }
      var year = nextDate.getFullYear();
      var ymd = year + '-' + month + '-' + day;

     var deliveryDate = (nextDateOk) ? ymd : '';

      var updatedorder = JSON.parse(JSON.stringify(this.order));

      if (address) {
        updatedorder.delivery_date = deliveryDate;
        updatedorder.address_id = address.id;
        //if there is no data then set it on autoship object to prevent user from proceeding
        if(deliveryDate == '') this.$store.commit('SET_ORDER_DETAILS', updatedorder);
        else this.$store.dispatch('updateCartOrder', updatedorder);
	  }



    var today = new Date();

    var self = this;

    $('#start_date').calendar({
      type: 'date',
      firstDayOfWeek:1,
      touchReadonly:true,
      maxDate:new Date(today.getFullYear(), today.getMonth()+3, today.getDate() + 1),
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),
      /*
      //removed as it requires reinitiate calendar after store is reloaded
      text: {
           days: ['Sv.', 'P', 'O', 'T', 'C', 'P', 'S'],
           months: ['Janvāris', 'Februāris', 'Marts', 'Aprīlis', 'Maijs', 'Jūnijs', 'Jūlijs', 'Augusts', 'Septembris', 'Oktobris', 'Novembris', 'Decembris'],
         },
        */
     formatter: {
       date: function (date, settings) {

         if (!date) return '';
         var day = date.getDate();
         if (day < 10) { day = '0' + day; }
         var month = date.getMonth(); //settings.text.months[];
         month++
         if (month < 10) { month = '0' + month; }
         var year = date.getFullYear();
         return year + '-' + month + '-' + day;
       }
    },
          // is the given date disabled?
    isDisabled: function (date, mode) {
      return self.isDateDisabled(date, mode, addressId);
      if(!date) return true;

    },
    onChange: function (date, text) {

      var day = date.getDate();
      if (day < 10) { day = '0' + day; }
      var month = date.getMonth(); //settings.text.months[];
      month++
      if (month < 10) { month = '0' + month; }
      var year = date.getFullYear();
      var ymd = year + '-' + month + '-' + day;

      var updatedorder = JSON.parse(JSON.stringify(self.order));

      updatedorder.delivery_date = ymd;
      updatedorder.address_id = address.id;

      self.$store.dispatch('updateCartOrder', updatedorder);

    },
    });


    //mutate date, but dont commit to server



  },700),


  changeDeliveryAddress(addressId){
    //pass selected address to calendar so that it can recalculate which days to show and which no
    this.activateCalendar(addressId)
  },



  /* end of calendar logic */

  removeItem: function(item) {

    this.$store.dispatch('removeOrderItem', item).then((response) => {
      this.$store.dispatch('loadOrderDetails', this.order.id);
    }).catch((error) => {
      console.error('Cart was not loaded')
    });
  },

  updateCartItemReturn: _.debounce(function(item, returnItems) {
    var updatedItem = JSON.parse(JSON.stringify(item)); //copy object
    updatedItem.return = returnItems;
    this.$store.dispatch('addOrderItem', [this.order.id, updatedItem]).then((response) => {
      this.$store.dispatch('loadOrderDetails', this.order.id);
    }).catch((error) => {
      console.error('Cart was not loaded')
    });

  }, 500),

  updateCartItemOrder: _.debounce(function(item, order) {

    if(order == "") return;
    //if(order == 0) this.removeItem(item)
    else {
      var updatedItem = JSON.parse(JSON.stringify(item)); //copy object
      updatedItem.order = order;
      this.$store.dispatch('addOrderItem', [this.order.id, updatedItem]).then((response) => {
        this.$store.dispatch('loadOrderDetails', this.order.id);
      }).catch((error) => {
        console.error('Cart was not loaded')
      });
    }

  }, 500),

  }

}
</script>



// WEBPACK FOOTER //
// WaitingForDeliveryEditPage.vue?4cde7d4c